module.exports = __webpack_public_path__ + "img/het-gel4.4e28ebc4.png";